module.exports = __webpack_public_path__ + "static/media/BGmifa.accc7e16.jpg";